module.exports = __webpack_public_path__ + "media/newstyle/images/epub-conversion-background-140f8eec9b208feceacf36a86dd373e1.png";